import { Theme, css } from '@emotion/react'

export const groupIconWrapper = (theme: Theme) => css`
  padding-right: ${theme.spacing(1.5)};
`

export const groupIcon = (theme: Theme) => css`
  border-radius: 50%;
  margin-left: ${theme.spacing(-1.5)};
`

export const table = (theme: Theme) => css`
  .table-row,
  .table-header {
    padding: ${theme.spacing(0.75, 0.75, 0.75, 1.5)};
  }
`
